
export default [
  {
    path: "/app/:userDeptRoleId/signatureInfo",
    name: "signatureInfo",
    component: () => import("../views/signatureInfo/signatureInfoIndex")
  }
];



// WEBPACK FOOTER //
// ./src/router/signatureInfo.js